"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetsCacheFileSchema = exports.NetsCacheEntrySchema = exports.NetsCacheConnectionSchema = exports.NETS_CACHE_SCHEMA_VERSION = void 0;
const zod_1 = require("zod");
exports.NETS_CACHE_SCHEMA_VERSION = 1;
exports.NetsCacheConnectionSchema = zod_1.z.object({
    designId: zod_1.z.string(),
    moduleRef: zod_1.z.string().describe('The module instance id.'),
    moduleName: zod_1.z.string().describe('The module reference designator (e.g. R1).'),
    pinRef: zod_1.z.string(),
});
exports.NetsCacheEntrySchema = zod_1.z.object({
    key: zod_1.z.string(),
    name: zod_1.z.string(),
    isGlobal: zod_1.z.boolean(),
    isHierarchical: zod_1.z.boolean(),
    designIds: zod_1.z.string().array(),
    connectionCount: zod_1.z.number().int().nonnegative(),
    connections: exports.NetsCacheConnectionSchema.array(),
});
exports.NetsCacheFileSchema = zod_1.z.object({
    projectModelId: zod_1.z.string(),
    schemaVersion: zod_1.z.literal(exports.NETS_CACHE_SCHEMA_VERSION),
    generatedAt: zod_1.z.string(),
    entries: exports.NetsCacheEntrySchema.array(),
});
//# sourceMappingURL=NetsCacheFile.js.map